import { useContext } from "react";
import { AppContext } from "../../Context/Context";
import Button from "../Reusables/Button/Button";
import InfoSmall from "../../assets/icons/infoSmall.png";
import "../../assets/css/DockDoor/dockDoor.css";

const LegendsButton = () => {
  const { setIsLegendsModalOpen } = useContext(AppContext);

  const openLegendsPopup = () => {
    setIsLegendsModalOpen(true);
    document.body.classList.add("prevent-scroll");
  };

  return (
    <div className="legend-btn-container">
      <Button
        onClick={openLegendsPopup}
        placeholder="Legends"
        btnClass="legend-btn"
        icon={InfoSmall}
      />
    </div>
  );
};

export default LegendsButton;
